import { render, staticRenderFns } from "./productAttributeStyle.vue?vue&type=template&id=7bdaf5fa&scoped=true"
import script from "./productAttributeStyle.vue?vue&type=script&lang=js"
export * from "./productAttributeStyle.vue?vue&type=script&lang=js"
import style0 from "./productAttributeStyle.vue?vue&type=style&index=0&id=7bdaf5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdaf5fa",
  null
  
)

export default component.exports